import { useQuery } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useDetailsByDeviceId(deviceId, options, key = "getDetailsByDeviceId") {
  const axiosPrivate = useAxiosPrivate();

  const getDetailsByDeviceId = async () => {
    const response = await axiosPrivate({
      method: "GET",
      url: `Device/Details/${deviceId}`,
    });

    return response.data;
  };

  return useQuery([key, deviceId], getDetailsByDeviceId, {
    ...options,
    enabled: !!deviceId,
  });
}

export default useDetailsByDeviceId;
